import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeywordsComponent } from './keywords.component';

import { FilterModule } from '../filter/filter.module';
import { AngularMaterialModule } from '../../material.module';
@NgModule({
    declarations: [
        KeywordsComponent
    ],
    imports: [
        CommonModule,
        FilterModule,
        AngularMaterialModule
    ],

    exports: [
        KeywordsComponent
    ],

    providers: [
    ]
})

export class KeywordsModule { }
